import DetailCard from 'v2/components/DetailCard';
import PesticideLicensesCard from 'v2/layouts/OrganizationWorkspaceLayout/components/OrganizationDetailsSection/components/PesticideLicensesCard';
import useOrganizationDetails from 'v2/layouts/OrganizationWorkspaceLayout/components/OrganizationDetailsSection/hooks/useOrganizationDetails';
import useTranslation from 'v2/layouts/OrganizationWorkspaceLayout/hooks/useTranslation';

import useFeatureFlags from 'hooks/useFeatureFlags';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const OrganizationDetailsSection: FunctionComponent<Props> = ({
    className = '',
    testId = TEST_ID
}) => {
    const {
        canEdit,
        certificationFields,
        companyFields,
        contactFields,
        handleEditCertifications,
        handleEditCompany,
        handleEditContact
    } = useOrganizationDetails();

    const { CERTIFICATIONS, COMPANY_DETAILS, EDIT, PERSON_OF_CONTACT } = useTranslation();

    const { STATE_REPORTING } = useFeatureFlags();

    return (
        <div className={`${className} ${styles.organizationDetailsSection}`} data-testid={testId}>
            <DetailCard
                editText={EDIT}
                fields={companyFields}
                onEdit={canEdit ? handleEditCompany : undefined}
                title={COMPANY_DETAILS}
            />

            <DetailCard
                editText={EDIT}
                fields={contactFields}
                onEdit={canEdit ? handleEditContact : undefined}
                title={PERSON_OF_CONTACT}
            />

            <DetailCard
                editText={EDIT}
                fields={certificationFields}
                onEdit={canEdit ? handleEditCertifications : undefined}
                title={CERTIFICATIONS}
            />

            {STATE_REPORTING ? <PesticideLicensesCard /> : null}
        </div>
    );
};

export default OrganizationDetailsSection;
